import React from 'react';
import styled from 'styled-components';
import { IconPlus } from '@/components/icons';
import { bookingDialog } from '@/components/shared/booking/form/BookingModal'
import useResponsive from '@/hooks/useResponsive';

interface AddBookingButtonProps {
  fullWidth?: boolean;
  label?: string;
}

const AddBookingButton: React.FC<AddBookingButtonProps> = ({ fullWidth, label }) => {
  const { isMobile } = useResponsive();

  return (
    <StyledButton $fullWidth={fullWidth} onClick={() => bookingDialog({})}>
      <span className="icon">
        <IconPlus />
      </span>
      {!isMobile && <span className="text">{label || "Добавить бронь"}</span>}
    </StyledButton>
  );
};

export default AddBookingButton;

const StyledButton = styled.div<{ $fullWidth?: boolean }>`
  background-color: #C12423;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  justify-content: center;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  &:hover {
    background-color: #b71c1c;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  .text {
    font-size: 16px;
    font-weight: 600;
  }
`;
